export default __webpack_public_path__ + "static/media/es.11f1ff12.svg";